import { z } from 'zod'

export type SignUpFormData = {
  firstName: string
  lastName: string
  email: string
  password: string
  confirmPassword: string
  invitationCode?: string
}

const passwordSchema = z
  .string()
  .min(8, 'signupForm.fields.password.errors.min_length')
  .max(70, 'signupForm.fields.password.errors.max_length')
  .regex(/[A-Z]/, 'signupForm.fields.password.errors.one_uppercase_letter')
  .regex(/[\W_]/, 'signupForm.fields.password.errors.one_special_char')

const emailSchema = z
  .string()
  .email('signupForm.fields.email.errors.invalid_email_address')
  .max(256)

export const signUpFormSchema = z
  .object({
    firstName: z.string().min(1, 'signupForm.fields.firstName.errors.too_short'),
    lastName: z.string().min(1, 'signupForm.fields.lastName.errors.too_short'),
    email: emailSchema,
    password: passwordSchema,
    confirmPassword: z.string(),
    invitationCode: z.string().optional()
  })
  .refine(data => data.password === data.confirmPassword, {
    message: 'signupForm.fields.confirmPassword.errors.not_match',
    path: ['confirmPassword']
  })
